import React, { Component } from "react";
import {
    Button,
    Input,
    Row,
    Col,
    Label
} from "reactstrap";
import Registry from "../../Utils/Registry";
import {NotificationManager} from "react-notifications";


class AccountPassword extends Component{
    constructor(props){
        super(props);

        this.inputChanged = this.inputChanged.bind(this);
        this.sendUpdate   = this.sendUpdate.bind(this);

        this.api = Registry.registered("api");

        let user = Registry.observe(this, "user", user => {
            this.setState({user: user});
        });

        this.state = {
            loading: false,
            user: user,
            errors:{
                old_password: false,
                new_password: false
            },
            fields: {
                old_password: "",
                new_password: "",
                new_password_confirm: ""
            }
        };
    }

    inputChanged(e, input_key){
        if(this.state.fields.hasOwnProperty(input_key)){
            let nState = this.state;

            nState.fields[input_key] = (typeof e === "string" ? e : e.target.value);
            nState.errors[input_key] = false;

            this.setState(nState);
        }
    }

    sendUpdate(){
        let nState = this.state;
        let error  = false;

        nState.errors.old_password = false;
        nState.errors.new_password = false;

        for(let k in this.state.fields){
            if(this.state.fields.hasOwnProperty(k) && this.state.fields[k] === ""){
                nState.errors[k] = true;
                error = true;
            }
        }

        if(!error && this.state.fields.new_password !== this.state.fields.new_password_confirm){
            NotificationManager.error("Les mot de passe ne correspondent pas");
            nState.errors.new_password = true;
            error = true;
        }

        this.setState(nState);

        if(!error){
            this.setState({
                loading: true
            });

            this.api.put("/customers/" + this.state.user.id, {
                old_password: this.state.fields.old_password,
                password: this.state.fields.new_password
            })
                .then(results => {
                    Registry.register("user", results.customer);
                    this.setState({loading: false}, () => {
                        NotificationManager.success(results.message);
                    });
                })
                .catch(error => {
                    let nState = this.state;
                    nState.loading = false;

                    if(error.hasOwnProperty("details"))
                        NotificationManager.error(error.details);

                    if(error.hasOwnProperty("subcode")){
                        if(error.subcode === "PUTCustomersInvalidPassword")
                            nState.errors.new_password = true;
                        else if(error.subcode === "PUTCustomersInvalidOldPassword" || error.subcode === "PUTCustomersMissingOldPassword")
                            nState.errors.old_password = true;
                    }

                    this.setState(nState);
                });
        }
    }

    render(){
        return (
            <Row>
                <Col xs="12" sm="12" lg="6">

                    <div className="ty-block">
                        <Row className="marg-b-10">
                            <Col md="12">
                                <Label style={this.state.errors.old_password ? {color: "red"}:{}} className="bold ">Ancien mot de passe</Label>
                                <Input type="password" onChange={e => this.inputChanged(e, "old_password")} value={this.state.fields.old_password} className="wp-100" required />
                            </Col>
                        </Row>
                        <Row className="marg-b-10">
                            <Col md="12">
                                <Label style={this.state.errors.new_password ? {color: "red"}:{}}  className="bold">Nouveau mot de passe</Label>
                                <Input type="password" onChange={e => this.inputChanged(e, "new_password")} value={this.state.fields.new_password} className="wp-100" required />
                            </Col>
                        </Row>
                        <Row className="marg-b-10">
                            <Col md="12">
                                <Label style={this.state.errors.new_password ? {color: "red"}:{}}  className="bold">Confirmer</Label>
                                <Input type="password" onChange={e => this.inputChanged(e, "new_password_confirm")} value={this.state.fields.new_password_confirm} className="wp-100" required />
                            </Col>
                        </Row>
                    </div>

                    <Row className="marg-b-15">
                        <Col md="12" className="center">
                            <Button className="text-uppercase" color="primary" onClick={this.sendUpdate}>
                                {this.state.loading ? <i className="ty-font icon icon-loading animated spin infinite f-18"> </i> : "Changer de mot de passe"}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default AccountPassword;



// WEBPACK FOOTER //
// ./src/components/Account/Password.js